import { render, staticRenderFns } from "./WSidebarLink.vue?vue&type=template&id=68e347c4&"
import script from "./WSidebarLink.vue?vue&type=script&lang=ts&"
export * from "./WSidebarLink.vue?vue&type=script&lang=ts&"
import style0 from "./WSidebarLink.vue?vue&type=style&index=0&id=68e347c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports